<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col cols="12" class="mt-4" :style="`width: ${contentWidth}px;`">
                        <h5 class="text-header">Keluhan</h5>
                        <template v-if="dataRM.anamnesa_keluhan && dataRM.anamnesa_keluhan.length > 0">
                            <span
                                v-for="(k, i) in dataRM.anamnesa_keluhan"
                                :key="i"
                                class="badge badge-keluhan mr-2"
                            >{{
                                k.description && k.description.toLowerCase().includes('lain')
                                ? k.lainnya
                                : k.description
                            }}</span>
                        </template>
                        <template v-else-if="dataRM.anamnesa.keluhan">
                            <div v-html="dataRM.anamnesa.keluhan"></div>
                            <template v-if="checkValueData(dataRM.anamnesa.keluhan_draw_path)">
                                <img :src="dataRM.anamnesa.keluhan_draw_path" class="img-fluid" alt="img" />
                            </template>
                        </template>
                        <template v-else>-</template>
                    </b-col>
                    <b-col cols="12" class="mt-4" :style="`width: ${contentWidth}px;`">
                        <h5 class="text-header">Anamnesa</h5>
                        <div v-html="dataRM.anamnesa.notes"></div>
                        <template v-if="checkValueData(dataRM.anamnesa.draw_path)">
                            <img :src="dataRM.anamnesa.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
                <b-row v-if="dataPasien && dataPasien.jenis_kelamin == '0'">
                    <b-col cols="12" class="mt-4">
                        <h5 class="text-header">Status Ibu Hamil</h5>
                        <span>{{ formatData(dataPasien.is_pregnant) }}</span>
                    </b-col>
                    <b-col cols="12" class="mt-4">
                        <h5 class="text-header">Status Ibu Menyusui</h5>
                        <span>{{ formatData(dataPasien.is_breastfeeding) }}</span>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <h5 class="text-header">Riwayat Kesehatan</h5>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Penyakit Jantung</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.penyakit_jantung) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Diabetes</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.diabetes) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Haemopilia</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.haemopilia) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Hepatitis</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.hepatitis) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Gastring</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.gastring) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Pengobatan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.penyakit_lainnya, dataRM.diagnosa.ket_penyakit_lainnya) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="text-header">Alergi & Kondisi Khusus</h5>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Penyakit</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_penyakit || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Alergi Obat</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ alergi.obat || '-' }}
                    </div>
                </div>
                <div class="row" v-if="checkLain('obat')">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Keterangan Riwayat Alergi Obat</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.ket_riwayat_alergi_obat || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Alergi Makanan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ alergi.makanan || '-' }}
                    </div>
                </div>
                <div class="row" v-if="checkLain('makanan')">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Keterangan Riwayat Alergi Makanan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.ket_riwayat_alergi_makanan || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Alergi Udara</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ alergi.udara || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Alergi Lain-lain</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_alergi_lain || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Riwayat Pengobatan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_pengobatan || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label text-title">Keterangan Lain</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        <div v-html="dataPasien.keterangan_lain || '-'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import rekamMedisMixin from '../mixins';

    export default {
        name: 'Subjective',
        mixins: [rekamMedisMixin],
        props: ['dataRM', 'dataPasien', 'poliGigi', 'pcareVersion'],
        data() {
            return {
                alergi: {
                    makanan: null,
                    udara: null,
                    obat: null,
                },
                contentWidth: 675,
            }
        },
        computed: {
        ...mapState(['sidebar']),
        ...mapGetters('sidebar', ['collapsed']),
            ...mapGetters(["getKlinikId"]),
        },
        watch: {
            dataRM() {
                this.buildData();
            },
            collapsed() {
                this.resizeWidth(window.innerWidth, this.collapsed);
            },
        },
        mounted() {
            this.resizeWidth(window.innerWidth, this.collapsed);
            this.buildData();
        },
        methods: {
            resizeWidth(w, collapsed = false) {
                let x = 2.845;

                let zoom = w / 19.2;
                if (collapsed) {
                if (zoom < 100) x = 2.725;
                else x = 2.478;
                } else if (zoom < 100) x = 3.35;

                this.contentWidth = w / x;
            },
            convertData(status, content = null) {
                if (status == 'T') {
                    return 'Tidak Ada';
                }
                if (status == 'Y') {
                    if (content) return `Ada, ${content}`;
                    else return 'Ada';
                }
                return '-';
            },
            buildData() {
                if (this.dataRM) {
                    this.setAlergiJenis();
                }
            },
            async setAlergiJenis() {
                if (this.dataRM.anamnesa) {
                    this.alergi.makanan = this.dataRM.anamnesa.riwayat_alergi_makanan;
                    this.alergi.udara = this.dataRM.anamnesa.riwayat_alergi_udara;
                    this.alergi.obat = this.dataRM.anamnesa.riwayat_alergi_obat;
                }
            },
            checkLain(type) {
                if (this.pcareVersion == '1' && this.alergi[type]) {
                    if (this.alergi[type].toLowerCase().includes('lain')) return true;
                }
                return false;
            },
            formatData(val) {
                let result = '-';
                if (val == '0') result = 'Tidak';
                else if (val == '1') result = 'Ya';
                return result;
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
    .badge-keluhan {
        color: #ffffff;;
        border-radius: 10px;
        background-color: #0e72db;
        text-transform: capitalize;
    }
</style>